import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faUserSecret,
  faUserTie,
  faUser,
  faEnvelopeOpen,
  faComments,
  faCalendarAlt,
  faBreadSlice,
  faCommentDots,
  faSignOutAlt,
  faChevronDown,
  faSearch,
  faList,
  faStopwatch,
  faMobile,
  faChevronLeft,
  faPaperclip,
  faPen,
  faTrash
} from "@fortawesome/free-solid-svg-icons";

import { faTimesCircle, faSave } from "@fortawesome/free-regular-svg-icons";
// import {} from "@fontawesome/free-brands-svg-icons";

// Solid
library.add(faUserSecret);
library.add(faUserTie);
library.add(faUser);
library.add(faEnvelopeOpen);
library.add(faComments);
library.add(faCalendarAlt);
library.add(faBreadSlice);
library.add(faCommentDots);
library.add(faSignOutAlt);
library.add(faChevronDown);
library.add(faSearch);
library.add(faList);
library.add(faStopwatch);
library.add(faMobile);
library.add(faChevronLeft);
library.add(faPaperclip);
library.add(faPen);
library.add(faTrash);

// Regular
library.add(faTimesCircle);
library.add(faSave);
